import { render, staticRenderFns } from "./tabDepartments.vue?vue&type=template&id=7e5a3ffa&scoped=true"
import script from "./tabDepartments.vue?vue&type=script&lang=js"
export * from "./tabDepartments.vue?vue&type=script&lang=js"
import style0 from "./tabDepartments.vue?vue&type=style&index=0&id=7e5a3ffa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e5a3ffa",
  null
  
)

export default component.exports